module.exports = __webpack_public_path__ + "img/icon3.86a99d7a.png";